'use client'

import { useSearchParams } from 'next/navigation'
import { Link } from '@/frontend/design-system/actions/Link'
import { P3 } from '@/frontend/design-system/typography/Paragraph'

export function RegisterButton() {
  const searchParams = useSearchParams()
  const redirectTo = searchParams.get('redirectTo') ?? '/app'

  return (
    <P3 className='text-center'>
      Chcesz założyć konto?{' '}
      <Link
        href={`/auth/register?redirectTo=${encodeURIComponent(redirectTo)}`}
        className='font-medium text-contentNavyAlgo hover:underline'
      >
        Zarejestruj się
      </Link>
    </P3>
  )
}
